import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, OnDestroy, Injector, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription, Observable } from 'rxjs';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Roles } from 'src/app/common/enumerations/enumerations';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { MessageBanner } from 'src/app/components/messages/services/message-banner';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { Role } from 'src/app/components/catalogs/roles/services/role';
import { User } from 'src/app/components/catalogs/user-catalog/services/user';
import { ProcedureObligationType } from '../enums/procedure-obligation-type.enum';
import { ProcedureCredited } from '../models/procedure-credited.model';
import { ProcedureTraining } from '../models/procedure-training.model';
import { Procedure } from '../models/procedure.model';
import { ProcedureTrainingService } from '../services/procedure-training.service';
import { ExtraProcedureTrainingPopupComponent } from './extra-procedure-training-popup/extra-procedure-training-popup.component';
import { UserService } from 'src/app/components/catalogs/user-catalog/services/user.service';
import { ProcedureTrainingActionsDialogComponent } from '../dialogs/procedure-training-actions-dialog/procedure-training-actions-dialog.component';

export class ProcedureTrainingTableInfo {
  trainingsWithRoles: any[] = [];
  trainingsWithoutRoles: any[] = [];
}

@Component({
  selector: 'app-procedure-training-v2',
  templateUrl: './procedure-training-v2.component.html',
  styleUrls: ['./procedure-training-v2.component.scss']
})
export class ProcedureTrainingV2Component extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {

  disabled!: boolean;
  loading = false;
  loadingMessage!: string;

  filterCtrl = new FormControl();

  errorMessages!: string[];
  headerOnTop!: boolean;

  valueFilter!: string;
  createdOn!: string;

  ///////
  tmpFilter!: string;
  condition!: string;
  filteredFilter!: any[];
  currentFilter: any;
  filter: any;

  ///////////////////////

  @ViewChild(MatSidenavContainer) sideNav!: MatSidenavContainer;
  @ViewChild('content') content!: ElementRef;
  @ViewChild(MatAccordion) accordion!: MatAccordion;
  @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;

  @ViewChildren('trainingContainer') trainingContainers!: QueryList<ElementRef<HTMLElement>>;
  @ViewChildren('extraTrainingHeader') extraTrainingHeaders!: QueryList<ElementRef<HTMLElement>>;

  private observers = new Map<number, IntersectionObserver>();

  admin!: boolean;
  supervised: User[] = [];
  activeUsers: User[] = [];
  user!: User;

  usersFiltered!: User[];
  userSelected!: User | null;
  usersInTables: User[] = [];
  usersColumns: string[] = ['name'];
  userName!: string;

  filterName?: string;
  filterValue = '';

  extraTrainingsPermission = false;
  enableUserManageTrainings = false;
  showTrainingsUserManages = false;
  showArchived = false;

  showAppendices = true;

  originalTrainings: any[] = [];
  trainingsToFilter: any[] = [];
  navId = -1;

  trainings: any[] = [];

  customCollapsedHeight = '60px';
  customExpandedHeight = '50px';

  prevScrollpos = window.pageYOffset;
  headerWidth = '';
  links = ['Procedure', 'KE Checklist', 'PPS Test', 'EPS Test', 'EPS Drawings', 'Rad Survey'];
  activeLink = this.links[0];


  procedures$!: Observable<Procedure[]>;
  allProcedures: Procedure[] = [];

  procedureTraining$!: Observable<ProcedureTraining[]>;
  procedureTrainingSubscription!: Subscription;
  procedureTrainings: ProcedureTraining[] = [];

  procedureCredited$!: Observable<ProcedureCredited[]>;
  procedureCreditedSubscription!: Subscription;
  proceduresCredited: ProcedureCredited[] = [];

  messageSubscription!: Subscription;
  messages$!: Observable<MessageBanner[]>;

  message_general_error!: MessageBanner;

  label_procedure_training!: string;
  label_procedure_number!: string;
  label_procedure_title!: string;
  label_revision!: string;
  label_complete!: string;
  label_completed!: string;
  label_obligation!: string;
  label_users_categories!: string;
  label_required_read_only!: string;
  label_required_follow_up!: string;
  label_recommended!: string;
  label_are_you_sure_you_want_to_delete_the_procedure!: string;
  label_training_complete_option!: string;
  label_training_remove_option!: string;

  constructor(
    protected override injector: Injector,
    private procedureTrainingService: ProcedureTrainingService,
    private userService: UserService,
  ) {
    super(injector);

  }
  ngAfterViewInit(): void {
    // Wait one microtask so QueryLists are stable after *ngFor renders
    queueMicrotask(() => this.setupExtraTitleObservers());

    // If your list changes dynamically, re-wire observers
    this.trainingContainers.changes.subscribe(() => this.setupExtraTitleObservers());
    this.extraTrainingHeaders.changes.subscribe(() => this.setupExtraTitleObservers());
  }

  override ngOnDestroy(): void {
    this.procedureCreditedSubscription?.unsubscribe();
    this.procedureTrainingSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    this.admin = this.hasPrivilege(PrivilegeEnum.ALSProcedureTrainingAdmin);

    this.setUsers();

    this.loadProcedureTrainings();
    this.loadProcedureCredited();

    this.extraTrainingsPermission = this.hasRoles([Roles.SA, Roles.PC]);;
    this.procedures$ = this.store.select(state => state.Procedures.data);
    this.procedures$.subscribe((data) => {
      if (data.length) {
        this.allProcedures = data?.filter(x => x.status == 1 && x.active).sort((a, b) => a.procedureNumber < b.procedureNumber ? -1 : 1);
        this.checkLoading();
      }
    });

    this.setLabels();
  }

  checkLoading() {
    this.cdRef.detectChanges();
    if (this.allProcedures.length && this.procedureTrainings.length && this.proceduresCredited.length) {
      this.format();
    }
  }

  /**
   * Loads active users for the header selector and prepares the initial display value.
   */
  setUsers() {
    this.userService.readSupervisedForTraining().subscribe(
      data => {
        this.supervised = data;
        this.enableUserManageTrainings = this.supervised.some(x => x.id != this.currentUser?.id);
        this.users = this.getUsers();
        this.activeUsers = this.sortUsersCurrentFirst(this.users.filter(x => x.status == 1));
        this.usersFiltered = this.activeUsers;
        this.userName = this.currentUser?.name ?? '';
        this.checkLoading();
      },
      error => {
        this.alert.defaultError();
        console.error(error);
      },
    );
  }

  loadProcedureTrainings() {
    this.procedureTraining$ = this.store.select(state => state.ProcedureTraining.data);
    this.procedureTrainingSubscription = this.procedureTraining$.subscribe((data: ProcedureTraining[]) => {
      if (data.length) {
        this.procedureTrainings = data;
        this.checkLoading();
      }
    });
  }

  loadProcedureCredited() {
    this.procedureCredited$ = this.store.select(state => state.ProcedureCredited.data);
    this.procedureCreditedSubscription = this.procedureCredited$.subscribe((data: ProcedureCredited[]) => {
      if (data.length) {
        this.proceduresCredited = data;
        this.checkLoading();
      }
    });
  }

  applyFilter(e: any) {
    this.filter = e;
  }

  filterUsers(e: any) {
    const value = e.target.value as string;
    this.usersFiltered = this.activeUsers.filter(x => x.name?.toLowerCase().includes(value.toLowerCase()));
  }

  setLabels() {
    this.label_procedure_training = this.getMessage('ALSPC_ProcedureTraining_ProcedureTraining')?.description;
    this.label_procedure_number = this.getMessage('ALSPC_ProcedureTraining_ProcedureNumber')?.description;
    this.label_procedure_title = this.getMessage('ALSPC_ProcedureTraining_Title')?.description;
    this.label_revision = this.getMessage('ALSPC_ProcedureTraining_Revision')?.description;
    this.label_complete = this.getMessage('ALSPC_ProcedureTraining_Complete')?.description;
    this.label_completed = this.getMessage('ALSPC_ProcedureTraining_Completed')?.description;
    this.label_obligation = this.getMessage('ALSPC_ProcedureTraining_Obligation')?.description;
    this.label_users_categories = 'Category';
    this.label_required_read_only = this.getMessage('ALSPC_RolesCatalog_Required_Read_Only')?.description;
    this.label_required_follow_up = this.getMessage('ALSPC_RolesCatalog_Required_Follow_Up')?.description;
    this.label_recommended = this.getMessage('ALSPC_RolesCatalog_Recommended')?.description;
    this.label_are_you_sure_you_want_to_delete_the_procedure = this.getMessage('ALSPC_RolesCatalog_AreYouSureYouWantToDeleteTheProcedure')?.description;
    this.label_training_complete_option = this.getMessage('Training_Complete_Option')?.description;
    this.label_training_remove_option = this.getMessage('Training_Remove_Option')?.description;
    if (!this.label_procedure_training) {
      setTimeout(() => {
        this.setLabels();
      }, 1000);
    }
  }

  /**
   * Builds the training panels for the selected user or the current user scope.
   * The users table intentionally remains based on the full scope so it can still
   * be used to switch users after a single user has been selected.
   */
  format() {
    if (!this.currentUser) { return; }

    if (!this.userName) {
      this.userName = this.currentUser.name ?? '';
    }

    const usersInScope = this.getUsersInScope();
    this.usersInTables = usersInScope;

    const users: User[] = this.sortUsersCurrentFirst(this.userSelected ? [this.userSelected] : usersInScope);
    this.trainings = users.map(user => ({
      user,
      loaded: false,
      loading: false,
      trainingsWithRole: null,
      trainingsWithoutRole: null,
      trainingsBeingUsed: [],
      hasPotentialActions: this.hasPotentialActions(user),
      showAppendices: this.showAppendices
    }));


    if (!this.userSelected) {
      this.originalTrainings = this.trainings;
    }
    this.trainingsToFilter = this.trainings;
    this.applyFilterTrainings();
    this.refreshExpandedPanels();
  }

  /**
   * Builds one user's training tables when their expansion panel is opened.
   * @param training The lightweight panel state for the user being expanded.
   */
  loadTrainingPanel(training: any) {
    if (training.loaded || training.loading) {
      return;
    }

    training.loading = true;
    const user = training.user as User;
    const userRoles = user.userRole?.map(x => x.roleID ?? 0) ?? [];
    const userProceduresCredited = this.proceduresCredited.filter(x => x.userID === user.id);
    const creditedProcedureIds = userProceduresCredited.map(x => x.procedureID);
    const userProcedureTrainings = this.procedureTrainings.filter(x =>
      (userRoles.includes(x.roleID ?? 0) && x.role && x.role.trainingRole) ||
      (!x.role && x.userID === user.id) ||
      creditedProcedureIds.includes(x.procedureMaster?.procedure?.id)
    );
    const userTrainings = this.getUserTrainings(userProcedureTrainings, userProceduresCredited, userRoles, user);

    training.trainingsWithRole = this.getTrainingsMatTableDataSource(userTrainings.trainingsWithRoles);
    training.trainingsWithoutRole = this.getTrainingsMatTableDataSource(userTrainings.trainingsWithoutRoles);
    training.trainingsBeingUsed = [...userTrainings.trainingsWithRoles, ...userTrainings.trainingsWithoutRoles];
    training.showAppendices = this.showAppendices;
    training.loaded = true;
    training.loading = false;

    this.applyFilterTrainings();
  }

  /**
   * Reloads panels that were already open after a display option invalidates their data.
   */
  refreshExpandedPanels() {
    queueMicrotask(() => {
      this.panels?.toArray().forEach((panel, index) => {
        if (panel.expanded && this.trainings[index]) {
          this.loadTrainingPanel(this.trainings[index]);
        }
      });
    });
  }


  getTrainingsMatTableDataSource(userTrainings: any): MatTableDataSource<any> | null {
    if (userTrainings.length) {
      const userTrainingsSource = new MatTableDataSource<any>(userTrainings);
      userTrainingsSource.filterPredicate = (data, filter) => {
        return data.procedure.procedureNumber.trim().toLowerCase().includes(filter.toLowerCase()) ||
          data.procedure.title.trim().toLowerCase().includes(filter.toLowerCase());
      };
      return userTrainingsSource;
    }
    return null;
  }

  getUserTrainings(userProcedureTrainings: ProcedureTraining[], userProceduresCredited: ProcedureCredited[], userRoles: number[], user: User): ProcedureTrainingTableInfo {
    const procedureIds: number[] = [];
    const trainingsInfo = new ProcedureTrainingTableInfo();

    const procedureTrainings = userProcedureTrainings?.map(x => x.procedureMaster?.procedure)
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort((a, b) => this.utils.sort(a?.procedureNumber, b?.procedureNumber, true));

    procedureTrainings.map(procedure => {
      if (!procedureIds.some(x => procedure?.id == x)) {
        let proceduresCredited = this.utils.cloneDeep(userProceduresCredited.filter(x => x.procedure?.procedureMasterID == procedure?.procedureMasterID).sort((a, b) => this.utils.sort(a.procedure?.version, b.procedure?.version, false)));

        const lastProcedureApproved = proceduresCredited.find(x => x.status == 1);
        if (lastProcedureApproved) {
          proceduresCredited = proceduresCredited.filter(p => p.procedureID != lastProcedureApproved.procedureID || (p.status == 1 && p.procedureID == lastProcedureApproved.procedureID));
        }
        if (procedure) {
          let obligationTypeText = this.getObligationTypeText(userProcedureTrainings.filter(x => (userRoles.includes(x.roleID ?? 0) && x.role) || (!x.role && x.userID == user.id)), procedure);
          let obligationType = this.getObligationType(userProcedureTrainings.filter(x => (userRoles.includes(x.roleID ?? 0) && x.role) || (!x.role && x.userID == user.id)), procedure);
          let trainingApplicableRoles = this.getApplicableRoles(userProcedureTrainings.filter(x => x.role?.trainingRole), procedure, userRoles);


          let trainingInfo = {
            procedure,
            procedureCredited: proceduresCredited[0],
            applicableRoles: trainingApplicableRoles,
            obligationType,
            obligationTypeText,
            creditedRev: lastProcedureApproved?.procedure?.revision,
            creditedDate: lastProcedureApproved?.dateCredited,
            creditedBy: lastProcedureApproved?.approver,
            showAppendices: this.showAppendices
          };

          if (trainingApplicableRoles.length) {
            trainingsInfo.trainingsWithRoles.push(trainingInfo);
          } else {
            trainingInfo.obligationTypeText = '';
            trainingsInfo.trainingsWithoutRoles.push(trainingInfo);
          }
          procedureIds.push(procedure?.id);
          if (this.showArchived) {
            const userProceduresCreditedArchived = userProceduresCredited.filter(x => x.procedure?.procedureMasterID == procedure?.procedureMasterID && x.procedure?.version != procedure.version).sort((a, b) => this.utils.sort(a.procedure?.version, b.procedure?.version, false));
            const procedureClone: Procedure = this.utils.cloneDeep(procedure);
            procedureClone.status = 0;
            obligationTypeText = this.getObligationTypeText(userProcedureTrainings, procedureClone);
            obligationType = this.getObligationType(userProcedureTrainings, procedureClone);
            trainingApplicableRoles = this.getApplicableRoles(userProcedureTrainings, procedureClone, userRoles);

            userProceduresCreditedArchived.map(userProcedCredited => {
              if (userProcedCredited.procedure) {
                userProcedCredited.procedure.status = 1;
                procedureClone.historyProcedure = true;

                trainingInfo = {
                  procedure: procedureClone,
                  procedureCredited: userProcedCredited,
                  applicableRoles: trainingApplicableRoles,
                  obligationType,
                  obligationTypeText,
                  creditedRev: userProcedCredited.procedure.revision,
                  creditedDate: userProcedCredited.dateCredited,
                  creditedBy: userProcedCredited.approver,
                  showAppendices: this.showAppendices
                };
              }

              if (trainingApplicableRoles) {
                trainingsInfo.trainingsWithRoles.push(trainingInfo);
              } else {
                trainingsInfo.trainingsWithoutRoles.push(trainingInfo);
              }
              procedureIds.push(procedure?.id);
            });
          }
        }

      }
    });

    return trainingsInfo;
  }

  getObligationType(userProcedureTrainings: ProcedureTraining[], procedure: Procedure) {
    return Math.max(...userProcedureTrainings.filter(userProcedures => userProcedures.procedureMasterID === procedure.procedureMasterID).map(o => o.obligationType));
  }

  getObligationTypeText(userProcedureTrainings: ProcedureTraining[], procedure: Procedure): string | null {
    const maxObligationType = Math.max(...userProcedureTrainings.filter(userProcedures => userProcedures.procedureMasterID === procedure.procedureMasterID).map(o => o.obligationType));
    let obligationTypeText: string | null = '';

    switch (maxObligationType) {
      case ProcedureObligationType.RequiredReadOnly:
        obligationTypeText = this.label_required_read_only;
        break;
      case ProcedureObligationType.RequiredFollowUp:
        obligationTypeText = this.label_required_follow_up;
        break;
      case ProcedureObligationType.Recommended:
        obligationTypeText = this.label_recommended;
        break;
      case ProcedureObligationType.Extra:
        obligationTypeText = null;
        break;
    }
    return obligationTypeText;
  }

  getApplicableRoles(userProcedureTrainings: ProcedureTraining[], procedure: Procedure, userRoles: number[]): (Role | undefined)[] {
    const applicableRoles = userProcedureTrainings.filter(userProcedures => userProcedures.procedureMasterID === procedure.procedureMasterID && userRoles.includes(userProcedures.roleID ?? 0)).map(o => o.role);
    return applicableRoles;
  }

  applyFilterTrainings(event?: any) {
    if (!this.userSelected && !this.showTrainingsUserManages) {
      this.filterName = this.currentUser?.name?.trim().toLowerCase();
    }
    if (this.userSelected) {
      this.filterName = this.userSelected?.name?.trim().toLowerCase();
    }

    if (this.filterName && !this.showArchived) {
      this.trainingsToFilter = this.originalTrainings.filter(x => x.user.name.trim().toLowerCase().includes(this.filterName));
    }

    if (event) {
      this.filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    }

    const containsName = this.originalTrainings.some(x => x.user.name.trim().toLowerCase().includes(this.filterValue)) && !this.filterName;
    let filterByName = containsName && this.filterValue !== '';
    if (this.userSelected && !filterByName) {
      const userFound = this.originalTrainings.some(x => x.user.name.trim().toLowerCase().includes(this.filterName));
      if (!userFound) {
        filterByName = true;
      }
    }
    if ((this.filterValue === this.currentUser?.name?.trim().toLowerCase() && !this.userSelected) || (this.filterName === this.currentUser?.name?.trim().toLowerCase() && !this.userSelected) || this.filterValue === this.userSelected?.name?.trim().toLowerCase()) {
      filterByName = true;
    }

    if (this.trainingsToFilter?.length && !this.userSelected) {
      this.trainings = this.trainingsToFilter;
    }

    if (filterByName && !this.userSelected) {
      const filter = this.filterName ? this.filterName : this.filterValue;
      this.trainings = this.originalTrainings.filter(x => x.user.name.trim().toLowerCase().includes(filter));
    }
    this.trainings.map(element => {
      if (element.trainingsWithRole) {
        element.trainingsWithRole.filter = filterByName && !this.filterName ? '' : this.filterValue;
      }
      if (element.trainingsWithoutRole) {
        element.trainingsWithoutRole.filter = filterByName && !this.filterName ? '' : this.filterValue;
      }
    });
    if (!this.trainingsToFilter?.length) {
      this.trainingsToFilter = this.trainings;
    }

    if (event) {
      this.openPanels();
    }

  }

  openPanels() {
    this.panels.map(panel => {
      if (!panel.expanded) {
        panel.open();
      }
    });
  }

  /**
   * Changes between the current-user view and the managed-user scope.
   * Clearing an explicit selection keeps the header value aligned with the active scope.
   * @param data Whether managed users should be included.
   */
  changeRolesUserManages(data: boolean) {
    this.showTrainingsUserManages = data;
    this.filterName = '';
    this.userSelected = null;
    this.userName = this.currentUser?.name ?? '';
    this.format();
  }

  changeArchived(data: any) {
    this.showArchived = data;
    this.format();
  }

  changeAppendices(data: any) {
    this.showAppendices = data;
    this.format();
  }

  /**
   * Applies a user chosen from the header autocomplete.
   * @param isSelected Whether the autocomplete option is the selected option.
   * @param user The user represented by the option.
   */
  getUserSelected(isSelected: boolean, user: User) {
    if (isSelected) {
      this.selectUser(user);
    }
  }

  /**
   * Selects a user from either the header autocomplete or the users table.
   * @param user The user whose procedure training should be displayed.
   */
  selectUser(user: User) {
    this.userSelected = user;
    this.userName = user.name ?? '';
    this.format();
  }

  /**
   * Returns to the current user while preserving the managed-user toggle state.
   */
  resetUserSelection() {
    this.userSelected = null;
    this.userName = this.currentUser?.name ?? '';
    this.format();
  }

  /**
   * Determines which users belong to the current table scope.
   * @returns The current user and, when enabled, the users they manage.
   */
  getUsersInScope(): User[] {
    if (!this.currentUser) {
      return [];
    }

    const users = [
      this.currentUser,
      ...(this.showTrainingsUserManages
        ? this.supervised.filter(x => x.id != this.currentUser?.id)
        : [])
    ];

    // Keep the table stable and prevent duplicate rows when the service returns the current user.
    return users.filter((user, index, allUsers) =>
      allUsers.findIndex(x => x.id === user.id) === index
    );
  }

  /**
   * Places the current user first and sorts the remaining users by full name.
   * @param users Users to order for a selector or accordion.
   * @returns A sorted copy of the supplied users.
   */
  sortUsersCurrentFirst(users: User[]): User[] {
    return users.slice().sort((a, b) => {
      if (a.id === this.currentUser?.id) {
        return -1;
      }
      if (b.id === this.currentUser?.id) {
        return 1;
      }

      const getName = (name: string | undefined) => name?.trim().toLocaleLowerCase() || '';
      return getName(a.name).localeCompare(getName(b.name));
    });
  }

  /**
   * Determines whether a user's panel may need a complete or approval action.
   * This lightweight check keeps header actions visible without building the full tables.
   * @param user The user represented by the panel.
   * @returns Whether the panel should show its multi-selection action controls.
   */
  hasPotentialActions(user: User): boolean {
    if (!this.currentUser?.id || !user.id) {
      return false;
    }

    const userProceduresCredited = this.proceduresCredited.filter(x => x.userID === user.id);
    if (user.id === this.currentUser.id) {
      return userProceduresCredited.some(credited =>
        credited.status != 0 && this.allProcedures.some(procedure =>
          procedure.procedureMasterID === credited.procedure?.procedureMasterID &&
          procedure.version !== credited.procedure?.version
        )
      );
    }

    const canApproveAnyPendingTraining = this.admin || this.hasRoles([Roles.SA, Roles.PC]);
    const userRoleIds = user.userRole?.map(role => role.roleID ?? 0) ?? [];

    return userProceduresCredited.some(credited =>
      credited.status === 0 &&
      (canApproveAnyPendingTraining || this.procedureTrainings.some(training =>
        training.procedureMasterID === credited.procedure?.procedureMasterID &&
        training.role?.trainingRole &&
        userRoleIds.includes(training.roleID ?? 0)
      ))
    );
  }

  /**
   * Preserves each user's accordion panel while panel data is loaded on demand.
   * @param item The user panel state rendered by the accordion.
   * @returns A stable user identifier for Angular's list tracking.
   */
  trackByIdentity(item: any) {
    return item.user?.id ?? item.name;
  }

  addProcedurePopup(training: any) {
    const selectedProcedures = training.trainingsBeingUsed.map((x: any) => x.procedure);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      allProcedures: this.allProcedures,
      selectedProcedures
    };

    dialogConfig.width = '30vw';
    const dialogRef = this.dialog.open(ExtraProcedureTrainingPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((procedure: Procedure) => {
      if (procedure) {
        this.procedureTrainingService.create({
          procedureMasterID: procedure.procedureMasterID,
          roleID: 0,
          obligationType: ProcedureObligationType.Extra,
          userID: training.user.id
        }).subscribe();
      }
    });
  }

  deleteTraining(procedureInfo: { procedureId: number, userId: number; }) {
    this.dialog.open(YesNoDialogComponent, {
      width: '25vw',
      data: {
        message: this.label_are_you_sure_you_want_to_delete_the_procedure,
      }
    }).afterClosed().subscribe(
      data => {
        if (data) {
          const procedureTraining = this.procedureTrainings.find(x => x.procedureMaster?.procedure?.id == procedureInfo.procedureId && x.roleID == 0 && x.userID == procedureInfo.userId);
          if (procedureTraining?.id)
            this.procedureTrainingService.delete(procedureTraining?.id).subscribe(
              () => { },
              () => {
                this.alert.defaultError();
              }
            );
        }
      }
    );
  }

  settings() {
    // const settings = this.dialog.open(ScfV2SettingsComponent, {
    //   width: '70vw',
    //   minWidth: '400px',
    //   minHeight: '400px',
    //   disableClose: true
    // });
    // settings.afterClosed().subscribe(() => {

    // });
  }


  navigate(id: number) {
    this.navId = id;
    document.getElementById('_' + id.toString())?.scrollIntoView({ behavior: 'smooth' });
  }

  private setupExtraTitleObservers(): void {
    // cleanup
    this.observers.forEach(o => o.disconnect());
    this.observers.clear();

    const containers = this.trainingContainers.toArray();
    const headers = this.extraTrainingHeaders.toArray();

    // Assumption: the nth container corresponds to the nth header within the same *ngFor item.
    // (This is true in your template as written.)
    for (let i = 0; i < Math.min(containers.length, headers.length); i++) {
      const containerEl = containers[i].nativeElement;
      const headerEl = headers[i].nativeElement;

      const panelId = this.extractUserIdFromId(containerEl.id); // traningContainer-123
      if (!panelId) continue;

      // Ensure training.showExtraTitle exists
      const training = this.trainings.find(t => t.user?.id === panelId);
      if (!training) continue;
      training.showExtraTitle = false;

      const obs = new IntersectionObserver(
        () => {
          // Compute “has header moved above container top?”
          const containerTop = containerEl.getBoundingClientRect().top;
          const headerTop = headerEl.getBoundingClientRect().top;

          // If header is above container top -> show title in expansion header
          training.showExtraTitle = headerTop <= containerTop;

          // If you use OnPush, uncomment:
          // this.cdr.markForCheck();
        },
        {
          root: containerEl,      // IMPORTANT: observe relative to container scroll
          threshold: [0, 1]
        }
      );

      // Observe the header itself; callback will run on scroll and layout changes
      obs.observe(headerEl);
      this.observers.set(panelId, obs);
    }
  }

  private extractUserIdFromId(id: string): number | null {
    // expects "traningContainer-123"
    const m = /traningContainer-(\d+)/.exec(id);
    return m ? Number(m[1]) : null;
  }

  selectMultiple(training: any, select: boolean) {
    training.selectMultiple = select;
    if (!select) {
      training.trainingsBeingUsed.forEach((t: any) => t.selected = false);
      training.trainingsWithRole?.data.forEach((t: any) => t.selected = false);
      training.trainingsWithoutRole?.data.forEach((t: any) => t.selected = false);
      training.selected = false;
    }
  }

  /**
   * Shows the panel-level multi-selection controls when action metadata is available.
   * @param training The user panel state.
   * @returns Whether the panel has actionable procedure training.
   */
  hasActions(training: any): boolean {
    return training.hasPotentialActions || training.trainingsBeingUsed?.some((t: any) => t.canComplete || t.canApprove || t.canCompleteAndApprove);
  }

  executeActions(training: any) {
    this.dialog.open(ProcedureTrainingActionsDialogComponent, {
      panelClass: 'draggable-dialog',
      width: '65vw',
      data: {
        training,
      }
    }).afterClosed().subscribe();
  }
}


